<form class="form-inline mx-3 my-1" (ngSubmit)="search(searchInput.value)">
    <div class="input-group">
      <div class="input-group-prepend">
        <button id="search-icon{{idSuffix}}" class="input-group-text fa-search" aria-label="Press to search for an app"
                ngbTooltip="Press &quot;ctrl + /&quot; to search Apps" placement="bottom auto">
        </button>
      </div>
      <input
          #searchInput
          type="search"
          id="search-bar{{idSuffix}}"
          class="form-control df-input-withicon"
          placeholder="Search Apps"
          aria-label="Search"
          aria-describedby="basic-addon1"
      />
    </div>
</form>
